// src/components/Header.js
import React from 'react';
import { signOut } from 'firebase/auth';
import { auth } from '../Config/Config';
import { LogOut, Menu } from 'lucide-react'; // Importing Menu icon from lucide
import { useNavigate } from 'react-router-dom';

const Header = ({ onSidebarToggle }) => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <header className="bg-gray-50 border-b border-gray-100 p-2 flex justify-center items-center relative">
      {/* Enhanced Mobile Menu Button */}
      <button 
        onClick={onSidebarToggle}
        className="group md:hidden absolute left-4 p-2 rounded-lg transition-all"
        aria-label="Toggle menu"
      >
        <Menu className="w-6 h-6 text-gray-600 group-hover:text-gray-900 group-active:scale-95 transition-all" />
        <span className="sr-only">Open menu</span>
      </button>
      
      {/* Premium Log Out Button */}
      <button
        onClick={handleLogout}
        className="flex items-center gap-2 px-4 py-2.5 rounded-lg text-white bg-gradient-to-br from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 transition-all duration-200 shadow-sm hover:shadow-md focus:outline-none focus:ring-2 focus:ring-red-400 focus:ring-offset-2"
      >
        <LogOut className="w-5 h-5" />
        <span className="font-medium tracking-tight">Sign Out</span>
      </button>
    </header>
  );
};

export default Header;